/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-05 09:53:30
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import './roleConfig.less';
import { createBEM, createNamespace } from 'src/util/bem';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import SysSideList from './components/sysSideList';
import FrameContentBg from 'src/pages/layout/components/frameContentBg';
import RoleConfigApi from './api/roleConfigApi';
import { Integer } from 'src/types/base';
import { Toast } from 'src/util/toast';
import EnumOperates from 'src/enums/enumOperates';
import alertRoleOperateModal from './roleOperateModal';
import { CommonUtil } from 'src/util/commonUtil';
import Button from 'src/types/iview/Button';
import EnumAuthorityType from 'src/enums/enumAuthorityType';
import { MenuI } from 'src/pages/store/modules/layout';
let bem = createBEM('role-config');

@Component({ name: 'role-config' })
export default class RoleConfig extends Vue.Component<any> {
    roles: { id: number; name: string }[] = [];
    currentRole: Integer = null;
    data: any = [];
    sourceData: any = [];
    loading: boolean = false;
    authorityMenusMap: any = {};
    async mounted() {
        await this.queryAllRoles();
        await this.queryAllMenu();
        this.selectFirst();
    }
    async queryAllMenu() {
        let menu = JSON.parse(JSON.stringify(this.$store.state.layout.menus));
        let { code, data } = await RoleConfigApi.queryAllMenu();
        if (code === 0) {
            let authorityMenusMap: any = {};
            data.data_info.forEach(i => {
                authorityMenusMap[i.power_url] = i.id;
            });
            this.authorityMenusMap = authorityMenusMap;
            this.sourceData = [
                {
                    title: '系统菜单',
                    expand: true,
                    children: this.filterMenu(menu),
                },
            ];
            this.data = JSON.parse(JSON.stringify(this.sourceData));
        }
    }
    async setMenu() {
        let menu = JSON.parse(JSON.stringify(this.sourceData));
        if (this.currentRole) {
            let { code, data } = await RoleConfigApi.queryAuthorityByRol(this.currentRole);
            if (code === 0) {
                data = data.filter(i => i.type === EnumAuthorityType.Menu.getId());
                CommonUtil.treeForEach(menu, (i: any) => {
                    if (!i.children || i.children.length === 0) {
                        let realMenu = data.find(sub => i.path === sub.power_url);
                        if (!realMenu) {
                            return;
                        }
                        i.checked = data.some(sub => i.path === sub.power_url);
                    }
                });

                this.data = menu;
            }
        }
    }
    filterMenu(menus: MenuI[]): MenuI[] {
        let t = this;
        console.log('this.', this.authorityMenusMap)
        return menus.filter(i => {
            if (CommonUtil.isArray(i.children) && i.children!.length > 0) {
                i.children = t.filterMenu(i.children as any);
            }
            if(!i.children ) {
                t.authorityMenusMap[i.path] && (i.id = t.authorityMenusMap[i.path])
                if(!t.authorityMenusMap[i.path]) {
                    console.log('请设置菜单【'+ i.title+'】：'+i.path)               }
            }
            if ((!i.children && t.authorityMenusMap[i.path]) || !CommonUtil.isResultEmpty(i.children)) {
                return true;
            } else {
                return false;
            }
        });
    }
    async queryAllRoles() {
        let { code, data } = await RoleConfigApi.searchList();
        if (code === 0) {
            this.roles = data.data_info.map(i => ({ id: i.id, name: i.role_name }));
        }
    }
    selectFirst() {
        if (this.roles[0]) {
            this.currentRole = this.roles[0].id;
            this.setMenu();
        }
    }
    async add(i) {
        let res = await alertRoleOperateModal(EnumOperates.Add.getName());
        if (res) {
            this.queryAllRoles();
        }
    }
    async update(i) {
        let res = await alertRoleOperateModal(EnumOperates.Update.getName(), i);
        if (res) {
            this.queryAllRoles();
        }
    }
    async delete(i: { id: number; name: string }) {
        if (await Toast.confirm()) {
            let { code } = await RoleConfigApi.delete(i.id);
            if (code === 0) {
                Toast.success('删除成功！');
                await this.queryAllRoles();
                // 删除的是当前选中的角色
                if (this.currentRole === i.id) {
                    this.selectFirst();
                }
            }
        }
    }
    roleChange(id: number) {
        this.currentRole = id;
        this.setMenu();
    }
    async save() {
        if (!this.currentRole) {
            Toast.error('请选择角色！');
            return;
        }
        let ids: number[] = [];
        CommonUtil.treeForEach(this.data, (i: any) => {
            if ((!i.children || i.children.length === 0) && i.checked) {
                ids.push(i.id);
            }
        });
        this.loading = true;
        let { code } = await RoleConfigApi.saveAuthority(this.currentRole, ids);
        if (code === 0) {
            Toast.success('保存成功');
        }
        this.loading = false;
    }
    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg padding={false} style="height: 100%">
                        <SysSideList
                            value={this.currentRole}
                            on-input={this.roleChange.bind(this)}
                            dataSource={this.roles}
                            title="角色"
                            on-add={this.add.bind(this)}
                            on-update={this.update.bind(this)}
                            on-delete={this.delete.bind(this)}
                        />
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div class={bem('right-menu-title')}>
                        功能权限设置
                        <Button type="primary" on-click={this.save.bind(this)}>
                            保存
                        </Button>
                    </div>
                    <FrameContentBg showCorner={false} radius={true}>
                        <div class={createNamespace('pa30')}>
                            <tree ref="tree" class={bem()} data={this.data} show-checkbox check-directly />
                        </div>
                    </FrameContentBg>
                </i-content>
            </layout>
        );
    }
}
